define([
	"jquery",
	"underscore",
	"backbone",
], function($, _, Backbone) {
	return Backbone.View.extend({
		el: '#content_layout',

		initialize: function(){

			if($("#modal_jp_promotion_container")){
                $("#modal_jp_promotion_container").modal('show');
			}
		}

	});
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/trading/special_promotion_view.js
// module id = 54
// module chunks = 0